var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 441.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007BFF",
    d: "m439.56 3.74 67.8 78.75c2.5 1.95 4.11 5 4.11 8.42 0 1.02-.14 2-.41 2.94l.94 336.97c0 5.86-4.75 10.62-10.62 10.62v.04H10.66C4.77 441.48 0 436.71 0 430.82V90.91c0-3 1.24-5.71 3.23-7.65L72.6 3.66c2.1-2.39 5.04-3.62 8-3.62V0h350.85c3.24 0 6.15 1.45 8.11 3.74zM34.04 80.25h443.25l-50.73-58.93H85.4L34.04 80.25zm180.35 270.4h83.23c4.82 0 8.75-3.95 8.75-8.74v-76.57h44.31c6.9-.31 11.81-2.58 14.64-6.88 7.68-11.52-1.96-23.77-10.08-30.9l-90.7-79.64c-7.71-8.52-18.71-8.52-26.42 0-10.53 12.29-63.8 59.73-83.42 81.81-6.79 7.66-15.21 18.1-8.13 28.73 2.84 4.3 7.74 6.57 14.65 6.88h44.43v76.57c0 4.8 3.93 8.74 8.74 8.74z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/unarchive.90dcb06ad044f867e4e5c749681af090.svg";
export { ForwardRef as ReactComponent };